export default "__VITE_ASSET__DcTnqyT___"